import React from "react";
import { useHistory } from "react-router-dom";
import CommonCard from "../Card/Card";
import { getMetricColor, hexToRgba } from "./calendarUtils";
import "./TimeSheetDetails.scss";

// Attestation Required + Rejected â€” the fixed status set this widget shows.
const NEEDS_ACTION_STATUS_KEYS = "8,3";

const TimeSheetDetails = ({ metricType, timesheetData, providerId, currentDate, scope = {} }) => {
  const buttonColor = getMetricColor(metricType);
  const history = useHistory();

  const handleViewAllClick = () => {
    history.push({
      pathname: "/pay_request_detail",
      state: {
        provider_id: providerId,
        provider_ids: scope.in_provider_ids ?? null,
        org_position_keys: scope.in_org_position_keys ?? null,
        periodFilter: "Monthly",
        currentMonth: (currentDate || new Date()).toISOString(),
        in_status: NEEDS_ACTION_STATUS_KEYS,
      },
    });
  };

  const handleCardClick=(timesheet)=>{
    history.push({
      pathname: "/pay_request_detail",
      state: {
        provider_id: providerId,
        provider_ids: scope.in_provider_ids ?? null,
        org_position_keys: scope.in_org_position_keys ?? null,
        periodFilter: "Monthly",
        currentMonth: (currentDate || new Date()).toISOString(),
        timesheet_status_mstr_key: timesheet.status?.timesheet_status_mstr_key,
        timesheet_key: timesheet.timesheet_mstr_key
      },
    });
  }

  return (
    <div className="timesheet-details-container">
      <CommonCard>
        <div className="timesheet-header">
          <span className="allDates-span">Needs Your Action</span>
          <button
            type="button"
            className="allDates-button"
            style={{ color: buttonColor, backgroundColor: hexToRgba(buttonColor, 0.12) }}
            onClick={handleViewAllClick}
          >
            View All
          </button>
        </div>
        <div className="timesheet-scroll-container">
          {timesheetData && timesheetData.length > 0 ? (
            timesheetData.map((timesheet) => (
              <div
                key={timesheet.timesheet_mstr_key || timesheet.id}
                className="timesheet-card-content"
                style={{ borderLeft: `3px solid ${timesheet.status?.color_code}` }}
                onClick={()=>{
                  handleCardClick(timesheet)
                }}
              >
                <div className="timesheet-card-left">
                  <div className="timesheet-card-info">
                    <h3 className="timesheet-card-title">{timesheet.contract_name}</h3>
                    <div className="timesheet-card-meta">
                      <span className="meta-item">{timesheet.status?.display_name}</span>
                      <span className="meta-separator">•</span>
                      {timesheet.rate_unit_type === "shift" ? (
                        <span className="meta-item">{timesheet.quantity ?? timesheet.shifts} Quantity</span>
                      ) : (
                        <span className="meta-item">
                          {timesheet.hours}h {timesheet.minutes}m
                        </span>
                      )}
                      <span className="meta-separator">•</span>
                      <span className="meta-item">${Number(timesheet.budget || 0).toFixed(2)}</span>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="timesheet-card-button"
                  style={{ borderColor: timesheet.status?.color_code, color: timesheet.status?.color_code }}
                >
                  {timesheet?.status?.display_name}
                </button>
              </div>
            ))
          ) : (
            <p>No timesheet data available</p>
          )}
        </div>
      </CommonCard>
    </div>
  );
};

export default TimeSheetDetails;